<template>
  <span>
    <v-menu nudge-top>
      <template v-slot:activator="{ on }">
        <v-btn color="primary" v-on="on">
          <v-icon small left dark>mdi-at</v-icon>Contact
        </v-btn>
      </template>
      <v-list>
        <v-subheader>CONTACT SUPPLIERS</v-subheader>
        <v-list-item @click="onConfirmMessage">
          <v-list-item-title>
            <v-icon class="pr-1" color="success" small>mdi-check</v-icon>Confirm
            Itinerary
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="onAmendmentMessage">
          <v-list-item-title>
            <v-icon class="pr-1" color="info" small>mdi-pencil</v-icon>Amendment
            Message
          </v-list-item-title>
        </v-list-item>
        <v-list-item @click="onCancelMessage">
          <v-icon class="pr-1" color="error" small>mdi-delete</v-icon>Cancel
          Itinerary
        </v-list-item>
        <v-list-item @click="onSendSupplierMessage">
          <v-icon class="pr-1" color="primary" small>mdi-at</v-icon>Send Message
        </v-list-item>
        <v-divider></v-divider>
        <v-subheader>CONTACT CLIENT</v-subheader>
        <v-list-item @click="onSendClientMessage">
          <v-icon class="pr-1" color="primary" small>mdi-at</v-icon>Send Message
        </v-list-item>
        <v-divider></v-divider>
        <v-subheader>CONTACT AGENT</v-subheader>
        <v-list-item @click="onSendAgentMessage">
          <v-icon class="pr-1" color="primary" small>mdi-at</v-icon>Send Message
        </v-list-item>
        <v-divider></v-divider>
        <v-subheader>FORMS</v-subheader>
        <v-list-item
          v-for="link in userExternalForms"
          :key="link.code"
          @click="onExternalLinkDetails(link)"
          >{{ link.name }}</v-list-item
        >
      </v-list>
    </v-menu>
    <itinerary-details-contact-suppliers-list
      :itinerary-id="itineraryId"
      :message-type="messageType"
      :show="contactSuppliersDialog"
      @close="contactSuppliersDialog = false"
    ></itinerary-details-contact-suppliers-list>
    <code v-if="debug">{{ userExternalForms }}</code>
  </span>
</template>

<script>
import gql from "graphql-tag";
import ItineraryDetailsContactSuppliersList from "./ItineraryDetailsContactSuppliersList";
const EXTERNAL_FORMS_LIST_QUERY = gql`
  query userExternalForms {
    userExternalForms {
      name
      code
      description
      isPaymentAmountRequired
    }
  }
`;
export default {
  name: "ItineraryDetailsContactSuppliers",

  components: {
    ItineraryDetailsContactSuppliersList,
  },

  props: {
    itineraryId: {
      type: String,
      default: "",
    },
  },

  data() {
    return {
      debug: false,
      contactSuppliersDialog: false,
      messageType: "",
    };
  },

  methods: {
    onConfirmMessage() {
      this.messageType = "confirm";
      this.contactSuppliersDialog = true;
    },
    onAmendmentMessage() {
      this.messageType = "amendment";
      this.contactSuppliersDialog = true;
    },
    onCancelMessage() {
      this.messageType = "cancel";
      this.contactSuppliersDialog = true;
    },
    onSendSupplierMessage() {
      this.$emit("contact-supplier");
    },
    onSendClientMessage() {
      this.$emit("contact-client");
    },
    onSendAgentMessage() {
      this.$emit("contact-agent");
    },
    onExternalLinkDetails(payload) {
      this.$emit("form-details", payload);
    },
  },

  apollo: {
    userExternalForms: {
      query: EXTERNAL_FORMS_LIST_QUERY,
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style scoped>
.main-content {
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/contact-suppliers/ItineraryDetailsContactSuppliers.vue